function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from '../../formMixin';
import dragEffect from '../../../components/js/draggableEffect';
import { swapElement } from '../../../components/js/common';
import Card from '../../../components/Card';
import EditMarket from './EditMarket.vue';
import vuedraggable from 'vuedraggable';
export default {
  name: 'NavListForm',
  mixins: [mixin, dragEffect],
  components: {
    Card: Card,
    EditMarket: EditMarket,
    vuedraggable: vuedraggable
  },
  data: function data() {
    return _defineProperty({
      activeSetting: 1,
      initData: {},
      form: {
        showType: 8,
        marketLists: [{}],
        marketPadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15,
          midP: 15
        },
        styleSetting: {
          titleAlign: 'center',
          showType: 2,
          sortType: 1,
          showTitle: 1,
          showPrice: 1,
          showPage: 1,
          pageLimit: 10,
          titleColor: null,
          bgImg: null,
          bgColor: null
        }
      },
      itemIndex: null,
      TITLE_ALIGN_OPTIONS: [{
        name: '左侧对齐',
        key: 'left'
      }, {
        name: '居中对齐',
        key: 'center'
      }, {
        name: '右侧对齐',
        key: 'right'
      }],
      SHOW_ALIGN_OPTIONS: [{
        name: '田字格',
        key: 1
      }, {
        name: '列表',
        key: 2
      }],
      SORT_OPTIONS: [{
        name: '综合排序',
        key: 1
      }, {
        name: '销量升序',
        key: 2
      }, {
        name: '销量降序',
        key: 3
      }, {
        name: '价格升序',
        key: 4
      }, {
        name: '价格降序',
        key: 5
      }]
    }, "SHOW_ALIGN_OPTIONS", [{
      name: '田字格',
      key: 1
    }, {
      name: '列表',
      key: 2
    }]);
  },
  props: {
    isAlone: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    propsData: {
      handler: function handler(propsData) {
        var _this$form;
        this.form = Object.assign(this.form, propsData);
        if (!((_this$form = this.form) !== null && _this$form !== void 0 && _this$form.marketPadding)) {
          this.$set(this.form, 'marketPadding', {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          });
        }
        ;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    swapElement: swapElement,
    uploadbgImg: function uploadbgImg(prop) {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _this.$set(_this.form['styleSetting'], prop, data[0].sattDir);
      });
    },
    handleRemove: function handleRemove(index) {
      this.form.marketLists.splice(index, 1);
    },
    addMarketContent: function addMarketContent() {
      this.form.marketLists.push({});
    },
    handleDragenter: function handleDragenter(index) {
      this.dragging = index;
      var currentIndex = index;
      var dragStartIndex = this.dragStartIndex;
      if (currentIndex !== dragStartIndex) {
        this.form.marketLists = this.swapElement(this.form.marketLists, currentIndex, dragStartIndex);
        this.dragStartIndex = currentIndex;
      }
    },
    settingMarketItem: function settingMarketItem(idx) {
      var _this$$refs$EditMarke;
      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      (_this$$refs$EditMarke = this.$refs['EditMarketRef']) === null || _this$$refs$EditMarke === void 0 ? void 0 : _this$$refs$EditMarke.openInit(idx, item);
    },
    saveEdit: function saveEdit(i, item) {
      var _this$form2;
      var lists = JSON.parse(JSON.stringify(((_this$form2 = this.form) === null || _this$form2 === void 0 ? void 0 : _this$form2.marketLists) || []));
      lists[i] = item;
      this.$set(this.form, 'marketLists', lists);
    }
  }
};